import { HttpContextToken } from '@angular/common/http';

export const HTTP_TIMEOUT_MS = new HttpContextToken<number | null>(() => null);
export const SKIP_HTTP_TIMEOUT = new HttpContextToken<boolean>(() => false);
export const SKIP_HTTP_SESSION_AUTH = new HttpContextToken<boolean>(() => false);
